export const QUICK_ACTION_STATE = "globalSearchAction";

export function dispatchCommand(entry, location, navigate) {
  const samePage = location.pathname === entry.path;
  const { [QUICK_ACTION_STATE]: previousCommand, ...state } = location.state || {};
  navigate(samePage
    ? { pathname: location.pathname, search: location.search, hash: location.hash }
    : entry.path, {
    state: {
      ...(samePage ? state : {}),
      ...(entry.command ? { [QUICK_ACTION_STATE]: entry.command } : {}),
    },
  });
}
